import {
  iconCommonProps, iconDefaultProps, iconPropTypes
} from '../propTypes';

const Burger = ({ className, color }) => {
  const props = {
    fill: 'none',
    strokeLinecap: 'round',
    strokeMiterlimit: 10,
    strokeWidth: '2px'
  };

  return (
    <svg
      className={ className }
      { ...iconCommonProps }
      viewBox='0 0 20 16.46'
    >
      <g>
        <line
          { ...props }
          stroke={ color }
          x1='1'
          x2='19'
          y1='1'
          y2='1'
        />
        <line
          { ...props }
          stroke={ color }
          x1='1'
          x2='11.22'
          y1='8.23'
          y2='8.23'
        />
        <line
          { ...props }
          stroke={ color }
          x1='1'
          x2='19'
          y1='15.46'
          y2='15.46'
        />
      </g>
    </svg>
  );
};

Burger.propTypes = { ...iconPropTypes };

Burger.defaultProps = { ...iconDefaultProps };

export default Burger;